import React, {useState, useEffect, useMemo} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/global.css';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt } from '@mui/icons-material';
import MenuAssociados from "../components/MenuAssociados";
    
function Avisos() {

    //constants
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [avisos, setAvisos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectStatus, setSelectStatus] = useState('');
    const [selectStatusLeitura, setSelectStatusLeitura] = useState(sessionStorage.getItem('selectStatusLeitura') || '99');
    const [isLoading, setIsLoading] = useState(false);
    const loggedIn = sessionStorage.getItem('loggedIn');
    const navigate = useNavigate();

    const now = new Date();
        const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
        year: 'numeric',
        day: '2-digit',
        month: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: false
        }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
        const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
        

    //functions
    
    function handlePesquisaStatusChange(event) {
        const value = event.target.value;
        setSelectStatus(value);
        sessionStorage.setItem('selectStatusRegistroAvisos', value);
    }
    function handlePesquisaStatusLeituraChange(event) {
        const value = event.target.value;
        setSelectStatusLeitura(value);
        sessionStorage.setItem('selectStatusLeitura', value);
    }
    function handleEditAviso(aviso) {
        navigate(`/Aviso/${aviso.IdAviso}`);
    }
    function handleLerAviso(aviso) {
        //console.log('Associado visualizando o aviso, será marcado como lido.');
                    // buscar na tabela de avisos lidos se o aviso já foi marcado como lido para o usuário logado
                    const dadosVerificacao = {
                        "IdAviso": aviso.IdAviso,
                        "IdPessoa": sessionStorage.IdPessoa
                    };
                    axios
                    .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=verificarAvisoLido',
                        dadosVerificacao, {
                        headers: {
                            "X-Access-Token": tokenAPI,
                            "Content-Type": "application/json; charset=UTF-8"
                        }
                    })
                    .then(response => {
                        //console.log(response.data);
                        if (response.data && parseInt(response.data.total) > 0) {
                            console.log('Aviso já marcado como lido para este usuário.');
                        } else {
                            console.log('Aviso ainda não foi marcado como lido para este usuário.');
                            //setBloqueio(true);
                            const dadosLeitura = {
                                "IdAviso": aviso.IdAviso,
                                "IdPessoa": sessionStorage.IdPessoa,
                                "avlLidoEm": customFormatDate,
                                "avlCodigoGUID": uuid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                            };
                            axios
                            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=marcarAvisoLido', 
                                dadosLeitura, {
                                headers: {
                                    "X-Access-Token": tokenAPI,
                                    "Content-Type": "application/json; charset=UTF-8"
                                }
                            })
                            .then(response => {
                                if (!response.data) {
                                    console.error('Erro ao marcar aviso como lido:', response.data);
                                }
                            })
                            .catch(error => {
                                console.error('Erro ao marcar aviso como lido:', error);
                            });
                        }
                    })
                    .catch(error => {
                        console.error('Erro ao verificar se o aviso foi marcado como lido:', error);
                    });
        navigate(`/Aviso/${aviso.IdAviso}`);
    }

    //effects
    //verifica se o usuário está logado e redireciona para o login se não estiver
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);

    //console.log(avisos);
    //carrega avisos ao montar o componente
    useEffect(() => {
    setIsLoading(true);
    if (parseInt(sessionStorage.pesAdmin) === 1) {
        console.log('Usuário é admin');
        axios
        .get(process.env.REACT_APP_API_URL + 
            '/routes.php?metodo=obterAvisos', 
            {
            headers: {
                "X-Access-Token": tokenAPI,
                "Content-Type": "application/json; charset=UTF-8"
            }
        })
        .then(response => {
            if (response.data) {
                if(response.data.message)
                {
                    setAvisos([]);
                }
                else{
                    setAvisos(response.data);
                    setIsLoading(false);
                }
                //console.log(response.data)
            } else {
                setAvisos([]);
                setIsLoading(false);
            }
        })
        .catch(error => {
            alert('Ocorreu um erro ao carregar os avisos. Por favor, tente novamente mais tarde.: ' + error.message);
            setIsLoading(false);
        });
    } else {
        console.log('Usuário não é admin');
        const dados = {
            "IdPessoa": sessionStorage.getItem('IdPessoa')
        };
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAvisosLidosPorPessoa',
            dados,
            {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
             }
        )
        .then(response => {
            if (response.data) {
                if(response.data.message)
                {
                    setAvisos([]);
                }
                else{
                    setAvisos(response.data);
                    setIsLoading(false);
                }
                //console.log(response.data)
            } else {
                setAvisos([]);
                setIsLoading(false);
            }
        })
        .catch(error => {
            alert('Ocorreu um erro ao carregar os avisos. Por favor, tente novamente mais tarde.: ' + error.message);
            setIsLoading(false);
        });
    }
    }, []);
    //atualiza avisos lidos na session
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const dados = {
            "IdPessoa": sessionStorage.getItem('IdPessoa')
        };
        axios
        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAvisosNaoLidos',
            dados,
            {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
             }
        )
        .then(response => {
            //console.log(response.data);
            if (response.data) {
                if(response.data.message)
                {
                    sessionStorage.setItem('avisosNaoLidos', 0);
                }
                else{
                    sessionStorage.setItem('avisosNaoLidos', response.data.length);
                }
            } else {
                sessionStorage.setItem('avisosNaoLidos', 0);
            }       
      });
    }, []);
    //console.log(avisos);
    
    //salvar log de navegação
    useEffect(() => {
        const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "Navegação",
        logModulo: "Página de Avisos",
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            //console.log(response.data[0].mensagem);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
        });
    }, []);

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = useState(config);

        const sortedItems = useMemo(() => {
            let sortableItems = [...items];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [items, sortConfig]);

        const requestSort = key => {
            let direction = 'ascending';
            if (sortConfig && 
                sortConfig.key === key && 
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
        };

        return { items: sortedItems, requestSort, sortConfig };
    };
    const { items, requestSort, sortConfig } = useSortableData(avisos);

    const getClassNamesFor = name => {
        if (!sortConfig) {
            return;
        }
        return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    //identificar a resolução da tela para ajustar o tamanho da tabela
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
        setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* Menu de navegação */}
                    <div>
                        <MenuAssociados />
                    </div>
                    {/* Titulos da página */}
                    <div className='headerMain'>
                        <label className='labelTitulo' >Avisos</label>
                        <label className='labelSubTitulo'>Comunicações aos Associados</label>
                    </div>
                    {/* Pesquisa filtro e Novo */}
                    <div className="containerBarraPesquisa">
                        <input className="inputBarraPesquisa"
                            placeholder="PESQUISAR"
                            type="text"
                            id="inputPesquisa"
                            name="inputPesquisa"
                            onChange={event => {
                                setSearchTerm(event.target.value)
                            }}
                        />

                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                        <select className="selectStatusPesquisa"
                        name="selectStatusRegistroAvisos"
                        selected={sessionStorage.selectStatusRegistroAvisos !== undefined ? sessionStorage.selectStatusRegistroAvisos : '99'}
                        onChange={event => {
                            handlePesquisaStatusChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusRegistroAvisos === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusRegistroAvisos === '1'} >ATIVOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusRegistroAvisos === '0'} >INATIVOS</option>
                        </select>
                        ) : ('')}

                        {parseInt(sessionStorage.pesAdmin) !== 1 ? (
                        <select className="selectStatusPesquisa"
                        name="SelectStatusLeitura"
                        selected={sessionStorage.selectStatusLeitura !== undefined ? sessionStorage.selectStatusLeitura : '99'}
                        onChange={event => {
                            handlePesquisaStatusLeituraChange(event)
                        }}
                        >
                        <option value={'99'} selected={sessionStorage.selectStatusLeitura === '99'} >TODOS</option>
                        <option value={'1'} selected={sessionStorage.selectStatusLeitura === '1'} >LIDOS</option>
                        <option value={'0'} selected={sessionStorage.selectStatusLeitura === '0'} >NÃO LIDOS</option>
                        </select>
                        ) : ('')}

                        {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <Link to="/Aviso/0">
                                <button className="buttonModalPadrao">
                                NOVO AVISO
                            </button>
                            </Link> ) : ('')}
                    </div>
                </div>
                {/* Tabela de dados */}
                {parseInt(sessionStorage.pesAdmin) === 1 ? (
                    <div className="tabelaPadrao">
                        {windowWidth < 769 ? (
                            isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items
                                .filter(aviso => {
                                    if (searchTerm === '') {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    } else if (
                                        aviso.aviTitulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        aviso.aviCriadoPor.toLowerCase().includes(searchTerm.toLowerCase()) //||
                                        //aviso.aviDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        //aviso.aviObservacoes.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    }
                                })
                                .map(aviso => (
                                    <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                        <div
                                            key={aviso.IdAviso}
                                            onClick={() => handleEditAviso(aviso)}
                                            className="p2" style={{ cursor: 'pointer' }} >
                                            <div>
                                                <p style={{ color: '#000' }}><b>TÍTULO: </b> {aviso.aviTitulo}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>RESPONSÁVEL: </b> {aviso.aviCriadoPor}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>PUBLICAÇÃO: </b> {aviso.aviCriadoEm}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>TRANSMISSÃO: </b> {parseInt(aviso.aviTransmitir) === 1 ? 'Sim' : 'Não'}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>CENTRAL: </b> {parseInt(aviso.aviCentral) === 1 ? 'Sim' : 'Não'}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>ATIVO: </b> {parseInt(aviso.aviStatus) === 1 ? 'Sim' : 'Não'}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>LEITURAS: </b> {aviso.leituras}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                        ) : (
                        <table className="tabelaDados">
                            <thead>
                                <tr style={{ cursor: 'pointer' }}>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('aviTitulo')} className={getClassNamesFor('aviTitulo')} >Titulo</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('aviCriadoPor')} className={getClassNamesFor('aviCriadoPor')} >Responsável</th>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('aviPublicacao')} className={getClassNamesFor('aviPublicacao')} >Publicação</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('leituras')} className={getClassNamesFor('leituras')} >Leituras</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('aviTransmitir')} className={getClassNamesFor('aviTransmitir')} >Transmissão</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('aviCentral')} className={getClassNamesFor('aviCentral')} >Central</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('aviStatus')} className={getClassNamesFor('aviStatus')} >Ativo</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                {
                                isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items
                                .filter(aviso => {
                                    if (searchTerm === '') {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    } else if (
                                        aviso.aviTitulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        aviso.aviCriadoPor.toLowerCase().includes(searchTerm.toLowerCase()) //||
                                        //aviso.aviDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        //aviso.aviObservacoes.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    }
                                })
                                .map(aviso => (
                                    <tr style={{ cursor: 'pointer' }} key={aviso.IdAviso}>
                                        <td className='tdAlignLeft Uppercase' onClick={() => handleEditAviso(aviso)} >{aviso.aviTitulo}</td>
                                        <td className='tdAlignLeft Uppercase' onClick={() => handleEditAviso(aviso)} >{aviso.aviCriadoPor}</td>
                                        <td className='tdAlignLeft Uppercase' onClick={() => handleEditAviso(aviso)} >{aviso.aviCriadoEm.substring(0,10)}</td>
                                        <td className='tdAlignCenter Uppercase' onClick={() => handleEditAviso(aviso)} >{aviso.leituras}</td>
                                        <td className='tdAlignCenter Uppercase' onClick={() => handleEditAviso(aviso)} >{parseInt(aviso.aviTransmitir) === 1 ? <ThumbUpAlt style={{ color: 'green' }} /> : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                                        <td className='tdAlignCenter Uppercase' onClick={() => handleEditAviso(aviso)} >{parseInt(aviso.aviCentral) === 1 ? <ThumbUpAlt style={{ color: 'green' }} /> : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                                    <td className='tdAlignCenter Uppercase' onClick={() => handleEditAviso(aviso)} >{parseInt(aviso.aviStatus) === 1 ? <ThumbUpAlt style={{ color: 'green' }} /> : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                ) : (
                    <div className="tabelaPadrao">
                        {windowWidth < 768 ? (
                            isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items
                                .filter(aviso => {
                                    if (searchTerm === '') {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    } else if (
                                        aviso.aviTitulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        aviso.aviCriadoPor.toLowerCase().includes(searchTerm.toLowerCase()) //||
                                        //aviso.aviDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        //aviso.aviObservacoes.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    }
                                })
                                .filter(aviso => {
                                    if (selectStatusLeitura === '99') {
                                        return aviso;
                                    } else if (selectStatusLeitura === '1') {
                                        return aviso.avlLidoEm !== ''; // Retorna apenas avisos lidos
                                    } else if (selectStatusLeitura === '0') {
                                        return aviso.avlLidoEm === ''; // Retorna apenas avisos não lidos
                                    } else {
                                        return aviso;
                                    }
                                })
                                .map(aviso => (
                                    <div style={{borderBottom: '1px solid #ccc', margin: '10px', backgroundColor: '#dfdada', borderRadius: '5px', padding: '10px' }}>
                                        <div
                                            key={aviso.IdAviso}
                                            onClick={() => handleLerAviso(aviso)}
                                            className="p2" style={{ cursor: 'pointer' }} >
                                            <div>
                                                <p style={{ color: '#000' }}><b>TÍTULO: </b> {aviso.aviTitulo}</p>
                                                <p style={{ color: '#000', marginTop: '10px' }}><b>PUBLICAÇÃO: </b> {aviso.aviCriadoEm}</p>
                                                <p style={{ color: aviso.avlLidoEm ? '#20b805' : '#db6e08', marginTop: '10px' }}><b>LIDO EM: </b> {aviso.avlLidoEm ? aviso.avlLidoEm : 'Não Lida'}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                        )
                        : (
                        <table className="tabelaDados">
                            <thead>
                                <tr style={{ cursor: 'pointer' }}>
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('aviTitulo')} className={getClassNamesFor('aviTitulo')} >Titulo</th>
                                    {/* <th style={{ textAlign: "left" }} onClick={() => requestSort('aviCriadoPor')} className={getClassNamesFor('aviCriadoPor')} >Responsável</th> */}
                                    <th style={{ textAlign: "left" }} onClick={() => requestSort('aviCriadoEm')} className={getClassNamesFor('aviCriadoEm')} >Publicação</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('aviLidoEm')} className={getClassNamesFor('aviLidoEm')} >Lido Em</th>
                                    <th style={{ textAlign: "center" }} onClick={() => requestSort('aviStatus')} className={getClassNamesFor('aviStatus')} >Ativo</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                isLoading ? <tr><td colSpan="6" style={{ width: "100%", textAlign: "center"}}><CircularProgress /></td></tr> :
                                items
                                .filter(aviso => {
                                    if (searchTerm === '') {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    } else if (
                                        aviso.aviTitulo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        aviso.aviCriadoPor.toLowerCase().includes(searchTerm.toLowerCase()) //||
                                        //aviso.aviDescricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        //aviso.aviObservacoes.toLowerCase().includes(searchTerm.toLowerCase())
                                    ) {
                                        if (selectStatus === '99') {
                                            return aviso;
                                        } else if (selectStatus === '1') {
                                            return parseInt(aviso.aviStatus) === 1; // Retorna apenas avisos ativos
                                        } else if (selectStatus === '0') {
                                            return parseInt(aviso.aviStatus) === 0; // Retorna apenas avisos inativos
                                        } else {
                                            return aviso;
                                        }
                                    }
                                })
                                .filter(aviso => {
                                    if (selectStatusLeitura === '99') {
                                        return aviso;
                                    } else if (selectStatusLeitura === '1') {
                                        return aviso.avlLidoEm !== ''; // Retorna apenas avisos lidos
                                    } else if (selectStatusLeitura === '0') {
                                        return aviso.avlLidoEm === ''; // Retorna apenas avisos não lidos
                                    } else {
                                        return aviso;
                                    }
                                })
                                .map(aviso => (
                                    <tr style={{ cursor: 'pointer' }} key={aviso.IdAviso}>
                                        <td className='tdAlignLeft Uppercase' onClick={() => handleLerAviso(aviso)} >{aviso.aviTitulo}</td>
                                        {/* <td className='tdAlignLeft Uppercase' onClick={() => handleLerAviso(aviso)} >{aviso.aviCriadoPor}</td> */}
                                        <td className='tdAlignLeft Uppercase' onClick={() => handleLerAviso(aviso)} >{aviso.aviCriadoEm ? aviso.aviCriadoEm.substring(0,10) : ''}</td>
                                        <td className='tdAlignCenter Uppercase' onClick={() => handleLerAviso(aviso)} >{aviso.avlLidoEm ? aviso.avlLidoEm.substring(0,10) : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                                        <td className='tdAlignCenter Uppercase' onClick={() => handleEditAviso(aviso)} >{parseInt(aviso.aviStatus) === 1 ? <ThumbUpAlt style={{ color: 'green' }} /> : <ThumbDownOffAlt style={{ color: 'red' }} />}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        )}
                    </div>
                )}
                
            </main>
        </div>
    );
}

export default Avisos;